import { CmsApplianceDetailsForm } from '../../models/appliance-details/cms-appliance-details-form.interface';

export const mockCmsApplianceDetailsForm: CmsApplianceDetailsForm = {
  brandCodeField: {
    fieldLabel: 'What brand is your appliance?',
    fieldRequired: true,
  },
  applianceCodeField: {
    fieldLabel: 'What kind of appliance are you registering?',
    fieldRequired: true,
  },
  purchasePriceField: {
    fieldLabel: 'How much did the appliance cost?',
    fieldHint: 'Approximately, how much did it cost?',
    fieldRequired: true,
  },
  purchaseDateField: {
    fieldLabel: 'When did you purchase it?',
    fieldHint: 'Select an approximate purchase date',
    fieldRequired: true,
  },
  retailerField: {
    fieldLabel: 'Which retailer did you purchase from?',
    fieldHint: 'Select a retailer',
    fieldRequired: false,
  },
  modelNumberField: {
    fieldLabel: 'Model number',
    fieldRequired: false,
  },
  serialNumberField: {
    fieldLabel: 'Serial number',
    fieldRequired: false,
  },
  warrantyField: {
    fieldLabel: 'Warranty',
    fieldHint: 'Select an approximate purchase date',
    fieldRequired: true,
  },
};
